import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttackAttack = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st9 {\n        fill: url(#radial-gradient);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient);\n      }\n\n      .st11 {\n        fill: none;\n        stroke: url(#linear-gradient8);\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    " }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient",
				x1: 34.1,
				y1: 55.29,
				x2: 76.53,
				y2: 55.29,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient1",
				x1: 18.02,
				y1: 53.7,
				x2: 23.9,
				y2: 53.7,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient2",
				x1: 27.14,
				y1: 55.85,
				x2: 31.01,
				y2: 55.85,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient3",
				x1: 23.69,
				y1: 63.1,
				x2: 31.84,
				y2: 63.1,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient4",
				x1: 20.8,
				y1: 47.34,
				x2: 30.58,
				y2: 47.34,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient5",
				x1: 19.72,
				y1: 38.73,
				x2: 23.97,
				y2: 38.73,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient6",
				x1: 27.21,
				y1: 41.09,
				x2: 34.33,
				y2: 41.09,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient7",
				x1: 27.89,
				y1: 34.01,
				x2: 37.67,
				y2: 34.01,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient8",
				x1: 5.17,
				y1: 51.08,
				x2: 94.84,
				y2: 51.08,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "radial-gradient",
				cx: 56.76,
				cy: 45.56,
				fx: 56.76,
				fy: 45.56,
				r: 14.89,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#fff"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient9",
				x1: 44.14,
				y1: 55.52,
				x2: 54.64,
				y2: 55.52,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient10",
				x1: 56.76,
				y1: 55.53,
				x2: 68.57,
				y2: 55.53,
				gradientTransform: "translate(0 101.09) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#4d04b1"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .98,
					stopColor: "#887ebb"
				})]
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st10",
				d: "M76.45,47.64c.21-2.43,0-4.88-.63-7.26s-1.65-4.61-3.04-6.62h0s0,0-.01-.02c-1.52-2.2-3.42-4.07-5.66-5.57-3.66-2.45-7.91-3.69-12.29-3.58-1.65.04-3.3.27-4.92.7-1.61.43-3.17,1.04-4.62,1.82-3.86,2.07-6.95,5.24-8.93,9.18-1.21,2.41-1.94,4.98-2.17,7.65v.04c-.21,2.42,0,4.85.63,7.23s1.65,4.61,3.04,6.62c1.52,2.21,3.43,4.09,5.67,5.59,3.52,2.35,7.58,3.59,11.77,3.59h.52c1.65-.04,3.3-.27,4.91-.7s3.17-1.04,4.62-1.81h0c3.86-2.07,6.95-5.24,8.93-9.18,1.2-2.4,1.94-4.97,2.17-7.63h0v-.05ZM70.95,34.45l-2.47,6.9-1.28.34c-.51.13-.81.65-.67,1.16.11.42.5.71.92.71.08,0,.16,0,.24-.03l1.28-.34,5.55,4.78c-.24,2.12-.83,4.18-1.75,6.11l-5.71,1.51-5.09-4.48,1.92-7.07c.09-.33,0-.68-.24-.92l-5.16-5.2,2.22-6.41,5.71-1.51c1.76,1.23,3.28,2.73,4.54,4.46h-.01ZM50.39,27.13c1.39-.37,2.81-.58,4.23-.63l3.44,3.6s.07.1.11.14l.71.72-2.22,6.41-6.68,1.76-5.09-4.48,1.65-6.06c1.22-.62,2.51-1.12,3.85-1.47h0ZM39.69,57.15l2.47-6.9,1.47-.39c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67l-1.47.39-5.55-4.78c.24-2.16.85-4.25,1.8-6.21l4.87-1.21s.08,0,.12-.02l.42-.11h0l.24-.06,5.09,4.48-1.92,7.07c-.09.33,0,.68.24.92l5.16,5.2-2.22,6.41-5.71,1.51c-1.76-1.23-3.28-2.73-4.54-4.46h.02ZM60.24,64.47c-.77.2-1.55.36-2.33.46l-6.12-4.4,2.18-6.31h0l2.79-.74s.03,0,.04,0l3.84-1.02,5.1,4.49-1.65,6.05c-1.22.62-2.51,1.12-3.85,1.47h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M23.87,46.61c-.13-.51-.65-.81-1.16-.67l-3.99,1.05c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16,0,.24-.03l3.99-1.05c.51-.13.81-.65.67-1.16h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M30.97,44.73c-.13-.51-.65-.81-1.16-.67l-1.97.52c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16,0,.24-.03l1.97-.52c.51-.13.81-.65.67-1.16h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st3",
				d: "M24.63,39.75c.08,0,.16,0,.24-.03l6.26-1.65c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67l-6.26,1.65c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st7",
				d: "M29.39,51.78l-7.89,2.08c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16,0,.24-.03l7.89-2.08c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st6",
				d: "M22.78,61.12l-2.35.62c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16,0,.24-.03l2.35-.62c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st4",
				d: "M28.4,61.6l5.23-1.38c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67l-5.23,1.38c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16,0,.24-.03h0Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st5",
				d: "M36.48,65.11l-7.89,2.08c-.51.13-.81.65-.67,1.16.11.43.5.71.92.71.08,0,.16-.01.24-.03l7.89-2.08c.51-.13.81-.65.67-1.16-.13-.51-.65-.81-1.16-.67h0Z"
			})
		] }),
		/* @__PURE__ */ _jsx("rect", {
			className: "st11",
			x: 7.17,
			y: 4.66,
			width: 85.67,
			height: 90.69,
			rx: 12,
			ry: 12
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st9",
			cx: 56.76,
			cy: 45.56,
			r: 14.89
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M44.83,52.46c-.48,0-.69-.21-.69-.69v-3.29c0-2.97,1.24-3.66,3.01-4.19l2.57-.8c.4-.11.52-.27.52-.69,0-.38-.13-.5-.52-.5h-4.16c-.48,0-.69-.21-.69-.69v-2.24c0-.48.21-.69.69-.69h5.65c2.18,0,3.37,1.11,3.37,3.18v1.8c0,1.93-1.13,2.81-2.99,3.39l-2.6.82c-.38.11-.5.15-.5.57v.4h5.46c.48,0,.69.21.69.69v2.24c0,.48-.21.69-.69.69,0,0-9.12,0-9.12,0Z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "st8",
			d: "M60.36,52.46h-2.91c-.48,0-.69-.21-.69-.69v-2.05c0-1.19.15-1.57.73-2.36l1.55-2.09-1.55-2.09c-.59-.79-.73-1.17-.73-2.36v-1.47c0-.48.21-.69.69-.69h2.95c.48,0,.69.21.69.69v1.32c0,.27,0,.56.17.8l.84,1.21c.13.21.25.33.46.33h.23c.21,0,.31-.12.46-.33l.86-1.21c.17-.25.17-.54.17-.8v-1.32c0-.48.21-.69.69-.69h2.91c.48,0,.69.21.69.69v1.47c0,1.19-.15,1.57-.73,2.36l-1.55,2.11,1.55,2.07c.59.79.73,1.17.73,2.36v2.05c0,.48-.21.69-.69.69h-2.91c-.48,0-.69-.21-.69-.69v-1.9c0-.27.02-.54-.17-.8l-.84-1.21c-.15-.23-.25-.33-.46-.33h-.27c-.21,0-.31.1-.46.33l-.86,1.21c-.19.27-.17.54-.17.8v1.9c0,.48-.21.69-.69.69Z"
		})] })
	]
});
export default SvgAttackAttack;
